import { useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import { GET_PERFORMANCE_REPORT } from "../Schema/Report";

const useGetPerformanceReport = ({ classId, performanceTypeId }) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const { refetch } = useQuery(GET_PERFORMANCE_REPORT, {
    variables: {
      classId: classId,
      performanceTypeId: performanceTypeId,
    },
    onCompleted: ({ getPerformanceReport }) => {
      setTableData(getPerformanceReport || []);
      setLoading(false);
    },
    onError: ({ message }) => {
      console.log("Error::", message);
    },
  });

  useEffect(() => {
    refetch();
  }, [classId, performanceTypeId]);

  return { tableData, loading, refetch };
};

export default useGetPerformanceReport;
